// extracted by mini-css-extract-plugin
export default {"container":"MobileCardLoader_container__BYS-T","singles":"MobileCardLoader_singles__C+SYT"};